import styled from 'styled-components';

interface SelectProps {
  error: boolean;
}

export const Container = styled.div<SelectProps>`
  width: 100%;

  .sel__control {
    transition: none;
    border-radius: 5px;
    border: 1px solid
      ${props => (!props.error ? props.theme.colors.inputBorder : '#e12325')};

    box-shadow: ${props => (!props.error ? '' : '0 0 0 0.5px #e12325')};
    background: transparent;

    .sel__value-container--has-value {
      color: ${props =>
        props.theme.title === 'light' ? '#555555' : '#ECF8FFee'} !important;
    }

    .sel__value-container {
      .sel__placeholder {
        font-size: 13px;
        color: #b0b0b0;
      }
      .sel__single-value {
        font-size: 13px;
        color: ${props =>
          props.theme.title === 'light' ? '#555555' : '#ECF8FFee'} !important;
      }
    }

    .sel__input {
      font-size: 13px;
      color: ${props =>
        props.theme.title === 'light' ? '#555555' : '#ECF8FFee'} !important;
    }
  }

  .sel__indicator-separator {
    display: none;
  }

  .sel__menu {
    background-color: ${props =>
      props.theme.title === 'light' ? '#ffffff' : '#262639'};
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    z-index: 1000;
    .sel__menu-list {
      padding: 0;
      .sel__option {
        color: #b5b5c3;
        background-color: ${props =>
          props.theme.title === 'light' ? '#ffffff' : '#262639'};
        transition: 0.15s ease;
        cursor: pointer;
        &.sel__option--is-focused,
        &.sel__option--is-selected {
          background-color: ${props =>
            props.theme.title === 'light' ? '#ECF8FF' : '#212E48'};
          color: #0095e8;
        }
      }
      &:first-child {
        border-radius: 10px 10px 0 0;
      }
      &:last-child {
        border-radius: 0 0 10px 10px;
      }
    }
  }

  .sel--is-disabled {
    .sel__control--is-disabled {
      background: #f2f2f2 !important;
      border-color: #e6e6e6 !important;

      .sel__value-container {
        .sel__placeholder {
          color: #808080 !important;
        }
      }
    }
  }
`;
